module.exports = __webpack_public_path__ + "static/media/integral.b58ceb51.svg";